import { AxiosPromise } from 'axios';
import baseRequest from './baseRequest';

interface VerifyMFATokenParams {
  token: string;
  rememberUser: boolean;
}

interface VerifyMFATokenResponse {
  success?: boolean;
  authyError?: boolean;
  authFailed?: boolean;
  message?: string;
}

export function verifyMFAToken(mfaId: string, body: VerifyMFATokenParams): AxiosPromise<VerifyMFATokenResponse | null> {
  return baseRequest.post(`/api/restrict/mfa/phone/${mfaId}/verify`, body);
}

interface SetupNewMFAParams {
  phoneNumber: string;
  deliveryMethod: 'sms' | 'call';
}

interface SetupNewMFAResponse {
  _id: string;
}

export function setupNewMFA(params: SetupNewMFAParams): AxiosPromise<SetupNewMFAResponse> {
  return baseRequest.post('/api/restrict/mfa/phone', params);
}

interface GetMFAMethodResponse {
  deliveryMethod: 'sms' | 'call';
  last4PhoneNumber: string;
}

export function getMFAMethod(mfaId: string): AxiosPromise<GetMFAMethodResponse> {
  return baseRequest.get(`/api/restrict/mfa/phone/${mfaId}`);
}

export function resendToken(mfaId: string): AxiosPromise<VerifyMFATokenResponse> {
  return baseRequest.post(`/api/restrict/mfa/phone/${mfaId}/resend`);
}
